import * as React from "react";
const baseCls = "rj-yourbet__btn";
export class Button extends React.Component {
    render() {
        const mdfr = this.props.modifier ? ` ${baseCls}--${this.props.modifier}` : "";
        return (React.createElement("button", { className: `${baseCls}${mdfr}`, "data-uat": this.props.dataUatButton, onClick: this.props.handler, disabled: this.props.disabled },
            React.createElement("span", { className: `${baseCls}-inner`, "data-uat": this.props.dataUatInner }, this.props.children)));
    }
}
//# sourceMappingURL=Button.js.map